import { styled } from "@mui/material/styles";
import { COLORS } from "../../constants/colors";

export const Sidebar = styled("div")`
  width: 250px;
  flex-shrink: 0;
  z-index: 2;
  position: fixed;
  top: 56px;
  left: 0;
  bottom: 0;
  background-color: ${COLORS.TEXT_WHITE};
  box-shadow: 1px 0px 0px ${COLORS.BORDER};
  display: flex;
  flex-direction: column;
`;

export const SidebarNew = styled("div")`
  width: 56px;
  flex-shrink: 0;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  padding: 1em 0;
  background-color: ${COLORS.THEME_SECONDARY};
  box-shadow: 1px 0px 0px ${COLORS.BORDER_MEDIUM};
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.5s ease-in-out;
`;
